// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import EventTimePreview from './EventTimePreview';

export default EventTimePreview;
